import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../../firebase";
export default function RejectedApprovalViewModal() {
  const navigate = useNavigate();

  const [RejectedStudents, setRejectedStudents] = useState([]);
  const [RejectedParents, setRejectedParents] = useState([]);
  const [RejectedTeachers, setRejectedTeachers] = useState([]);
  const [Refresh, setRefresh] = useState(true);
  const [UserId, setUserId] = useState("");

  const [IsLoading, setIsLoading] = useState(true);

  let schoolId = localStorage.getItem("schoolId");
  schoolId = JSON.parse(schoolId);

  useEffect(() => {
    const fetchData = () => {
      if (schoolId) {
        GetRejectedTeachers();
        GetRejectedStudents();
        GetRejectedParents();
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [Refresh]);

  const GetRejectedTeachers = async () => {
    let UsersRef = collection(db, "Users");
    let tempArray = [];
    const q = query(
      UsersRef,
      where("UserType", "==", "teacher"),
      where("IsVerified", "==", 2),
      where("SchoolID", "==", schoolId)
    );

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      tempArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setRejectedTeachers([...tempArray]);
  };

  const GetRejectedStudents = async () => {
    let UsersRef = collection(db, "Users");
    let tempArray = [];

    const q = query(
      UsersRef,
      where("UserType", "==", "student"),
      where("IsVerified", "==", 2),
      where("SchoolID", "==", schoolId)
    );

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      tempArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setRejectedStudents([...tempArray]);
  };
  const GetRejectedParents = async () => {
    let UsersRef = collection(db, "Users");
    let tempArray = [];

    const q = query(
      UsersRef,
      where("UserType", "==", "parent"),
      where("IsVerified", "==", 2),
      where("SchoolID", "==", schoolId)
    );

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      tempArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setRejectedParents([...tempArray]);
  };

  const ApproveUser = (uid) => {
    let DocRef = doc(db, "Users", uid);
    setDoc(
      DocRef,
      {
        IsVerified: 1,
      },
      { merge: true }
    );
    setRefresh(!Refresh);
  };
  // Action Confirmation Start
  const [RejectedDialog, setRejectedDialog] = useState(false);

  const handleOpenDialog = (id) => {
    setUserId(id);
    setRejectedDialog(true);
  };

  const handleCloseDialog = async (rej) => {
    setRejectedDialog(false);
    if (rej === true) {
      ApproveUser(UserId);
      setRejectedDialog(false);
      setRefresh(!Refresh);
    }
  };
  // Action Confirmation End

  return {
    RejectedStudents,
    RejectedParents,
    RejectedTeachers,
    ApproveUser,
    RejectedDialog,
    handleOpenDialog,
    handleCloseDialog,
    IsLoading,
    navigate,
  };
}
